import InlineEditSelect from './InlineEditSelect';

export default InlineEditSelect;
